import { c as _c } from "react/compiler-runtime";
import type { FootprintAppearance } from '@onefootprint/footprint-js';
import { useEffect } from 'react';
type ApplyDarkClassProps = {
  appearance?: FootprintAppearance | null;
};
const ApplyDarkClass = t0 => {
  const $ = _c(4);
  const {
    appearance
  } = t0;
  let t1;
  if ($[0] !== appearance?.theme) {
    t1 = () => {
      const isDark = appearance?.theme === "dark" || appearance?.theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches;
      document.body.classList.toggle("dark", isDark);
      return _temp;
    };
    $[0] = appearance?.theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== appearance) {
    t2 = [appearance];
    $[2] = appearance;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};
export default ApplyDarkClass;
function _temp() {
  document.body.classList.remove("dark");
}